import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { onSaveImageData } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { ImageSaveType } from '../../../../redux-store/types/nct';
import { OTP_ACTIONS } from '../../../../utils/constants';
import UploadDocumentScreen from '../UploadDocumentScreen';
import en from '../../../../lang/en-us';
const { dashboard } = en;

function ChangeEmailDocument(props: any) {
    const [Document, setDocument] = useState<any>({
        image: { name: 'EMAIL_CHANGE', format: '', content: '' },
    });

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
    }, []);

    const handleImageSelection = (value: any, format: any) => {
        setDocument({
            image: {
                ...Document.image,
                format: format,
                content: value,
            },
        });
    };

    const handleSubmission = () => {
        props.history.replace('change-email', {
            images: [Document.image],
            action: OTP_ACTIONS.NEW_EMAIL_OFFLINE_OTP,
            ...(props?.location?.state || {}),
        });
    };

    // save image in store
    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: [Document.image],
                type: 'CHANGE_EMAIL',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [Document]);

    return (
        <div className="curved-bg">
            <UploadDocumentScreen
                backLink="nct/change-email"
                heading={dashboard.changeEmail.changeEmailHeading}
                subheading={dashboard.changeEmail.UploadDocument.subHeading}
                info1={dashboard.changeEmail.UploadDocument.subHeadingInfo1}
                linkText={dashboard.changeEmail.UploadDocument.subHeadingInfo2}
                info2={dashboard.changeEmail.UploadDocument.subHeadingInfo3}
                nextLink="change-email"
                id="upload-scanned-document"
                onImageSelected={handleImageSelection}
                handleSubmit={handleSubmission}
                isDisabled={!!Document.image.content}
                hrefLink={process.env.REACT_APP_S3_CLOUD_URL + '/Updation_of_Email_Id.docx'}
            />
        </div>
    );
}
export default connect(null, { onSaveImageData })(ChangeEmailDocument);
